// OrgSubnav — horizontal org-section nav. Pill tabs come from orgSections; settings lives
// in the page heading row (OrgSettingsLayout), not here.
import TabNav from '@/components/layout/TabNav';
import { visibleOrgSections } from '@/components/layout/orgSections';
import { useAccess } from '@/hooks/useAccess';

export interface OrgSubnavProps {
  orgSlug: string;
  isOrgAdmin: boolean;
}

export default function OrgSubnav({ orgSlug, isOrgAdmin }: OrgSubnavProps) {
  const { tier } = useAccess();
  const items = visibleOrgSections(orgSlug, isOrgAdmin, tier)
    .filter((section) => section.placement !== 'trailing')
    .map((section) => ({
      to: section.to,
      label: section.label,
      icon: section.icon,
      end: true, // org section routes are exact destinations
    }));

  return <TabNav items={items} ariaLabel="Organization sections" />;
}
